<div class="homepage__intro-credits">
  <h2 class="homepage__experience-description font-uppercase font-normal">
    Narration<br />intéractive
    <span>
      Musée des beaux-arts<br />// bordeaux
    </span>
  </h2>
</div>

<style lang="scss">
  @import '../var';

  .homepage {
    &__intro-credits {
      font-family: $text-font;
      color: $primary-color;
    }

    &__experience-description {
      display: flex;
      justify-content: space-between;
      font-size: clamp(12px, 3.75%, 18px);
      margin: 0;
    }
  }
</style>
